<template>
	<!--헤더-->
	<div class="header">
		<div class="header__top">
			<h1 class="logo">
				<a href="#" @click.prevent="goMenu('logo')">
					<img class="logo--base" src="@/assets/common/ezqar logo_W.png" alt="SuBPay">
					<img class="logo--sm" src="@/assets/common/ezqar logo_W.png" alt="SuBPay">
					<img class="logo--symbol" src="@/assets/common/ezqar logo_W.png" alt="SuBPay">
				</a>
			</h1>
			<div class="login-info">
				{{checkUserId.organizationName}}
				<div class="login-info__detail">
					<p class="login-info__name"><em>{{checkUserId.memberName}}님</em> <span>환영합니다.</span></p>
					<div class="login-info__btns">
						<a href="#" class="login-info__setting" @click="goMenu('myPage')" >마이 페이지</a>
						<router-link to="/login" v-if="checkUserId.memberCode != ''" @click="logOut">로그아웃</router-link>
					</div>
				</div>
			</div>
		</div>
		<button type="button" class="btn__menu btn__gnb"><span></span></button>
		<div class="gnb">
			<p class="gnb__tit">MENU</p>
			<ul class="gnb__menu">
				<li v-if="checkUserId.privilege == 'sAdmin'" :class="{ 'on': isOrgRoute }">
					<button type="button" class="icon-layout" @click="goMenu('organization')"><span>기관별 평가현황</span></button>
				</li>

				<li :class="{ 'on': isGiasRoute }" v-if="checkUserId.privilege == 'admin' || (checkUserId.privilege == 'user' && checkUserId.subRole == null)">
					<button type="button" class="icon-alert" v-if="checkUserId.privilege != 'sAdmin'"  ><span>평가</span></button>
					<ul>
						<li :class="{ 'on': isIQAGiasInputRoute }" v-if="checkUserId.privilege == 'user' || checkUserId.privilege == 'sAdmin' ">
							<a @click="goMenu('IQAgiasInput')" src="">IQA품질평가 실시</a>
						</li>
						<li :class="{ 'on': isIQCGiasInputRoute }" v-if="checkUserId.privilege == 'admin' || checkUserId.privilege == 'sAdmin' ">
							<a @click="goMenu('IQCgiasInput')" src="">IQC품질평가 실시</a>
						</li>
						<li :class="{ 'on': isGiasStatsRoute }"> 
							<a @click="goMenu('giasStats')" src="">품질평가 현황</a>
						</li>
						<li :class="{ 'on': is2024GiasStatsRoute }">
							<a @click="goMenu('gias2024Stats')" src="">2024년도 평가결과</a>
						</li>
						<li :class="{ 'on': isGiasEditRoute }" v-if="checkUserId.privilege == 'sAdmin'"> 
							<a @click="goMenu('giasEdit')" src="">GIAS항목편집</a>
						</li>
						<!-- <li> 
							<a @click="goMenu('tempList')" src="">임시메뉴</a>
						</li> -->
					</ul>
				</li>
	
	
	
				
				<!-- 토글 방식으로 수정 -->
				<li v-if="checkUserId.privilege != 'user'" :class="{ 'on': adminMenuOpen }">
					<!-- 버튼 클릭 시 열림/닫힘 -->
					<button type="button" class="icon-person" @click="toggleAdminMenu">
						<span>기관 관리</span>
					</button>
					
					<!-- adminMenuOpen이 true일 때만 서브메뉴 표시 -->
					<ul v-show="adminMenuOpen">
						<li :class="{ 'on': route.name === 'admin' }">
						<a @click="goMenu('admin')">평가원 관리</a>
						</li>
						<li :class="{ 'on': route.name === 'organizationMgr' }" v-if="checkUserId.privilege == 'sAdmin'">
						<a @click="goMenu('organizationMgr')">기관 관리</a>
						</li>
					</ul>
				</li>
	
	
	
	
	
				<li v-if="checkUserId.privilege != 'user'" :class="{ 'on': isNoticeRoute }">
					<button type="button" class="icon-document-check" @click="goMenu('noticeList')"><span>공지 사항</span></button>
				</li>
				<li v-if="checkUserId.privilege == 'user'" :class="{ 'on': isNoticeRoute }">
					<button type="button" class="icon-document-check" @click="goMenu('noticeList')"><span>공지 사항</span></button>
				</li>

				<li v-show="checkUserId.privilege == 'admin' && showcertificateMenu == true" :class="{ 'on': isCertificateRoute }">
					<button type="button" class="icon-presentation" @click="goMenu('certificate')"><span>품질등급 확인서</span></button>
				</li>

				<!-- <li v-if="showcertificateMenu" :class="{ 'on': isCertificateRoute }">
					<button type="button" class="icon-presentation" @click="goMenu('certificate')"><span>품질등급 확인서</span></button>
				</li> -->

				<!-- <li v-if="showcertificateMenu" :class="{ 'on': isCertificateRoute }">
					<button type="button" class="icon-presentation" @click="goMenu('certificate')">
						<span>품질등급 확인서</span>
					</button>
				</li> -->

				<li v-if="checkUserId.subRole != null " :class="{ 'on': isOrgRoute }">
					<button type="button" class="icon-layout" @click="goMenu('orgList')"><span>기관 평가하기</span></button>
				</li>
					<li v-if="checkUserId.privilege == 'sAdmin'" :class="{ 'on': isEvalRouter }">
					<button type="button" class="icon-person"><span>평가자 관리</span></button>
					<ul>
						<li :class="{ 'on': isCreateEval }">
							<a @click="goMenu('createEval')" src="">평가자 계정 생성</a>
						</li>
						<li :class="{ 'on': isEvalList }" v-if="checkUserId.privilege == 'sAdmin'" > 
							<a @click="goMenu('evalList')" src="">평가자 계정 관리</a>
						</li>
						<!-- <li> 
							<a @click="goMenu('tempList')" src="">임시메뉴</a>
						</li> -->
					</ul>
					<!-- <button type="button" class="icon-person" @click="goMenu('admin')" ><span>기관 관리</span></button> -->
				</li>
				<!-- 방문자 카운트 표시 -->
			<!-- <div class="visitor-count" v-if="checkUserId.privilege == 'sAdmin'">
				<p>방문자 통계</p>
				<p>오늘: {{ visitorCounts.dailyCount }}</p>
				<p>이번 주: {{ visitorCounts.weeklyCount }}</p>
				<p>이번 달: {{ visitorCounts.monthlyCount }}</p>
				<p>총 방문자: {{ visitorCounts.totalCount }}</p>
			</div> -->
			</ul>
			<button type="button" class="icon-left-circle btn__collapse"><span>메뉴접기</span></button>
		</div>
		<div class="gnb__bg"></div>
	</div>
	</template>
	
	<script setup>
	import { useStore } from 'vuex'
	import { computed,onMounted,ref, watch  } from 'vue'
	import { useRouter, useRoute } from 'vue-router'
	import { getCurrentInstance } from "vue";
	import { selectVisitorCount } from '@/api/user'
	import { selectCertStatus } from '@/api/org'
	const route = useRoute();
	const router = useRouter()
	const store = useStore()
	const checkUserId = computed(() => store.state.temp.userInfo )
	// "기관 관리" 메뉴 열림/닫힘 상태
	const adminMenuOpen = ref(false)
	
	// "기관 관리" 버튼 클릭 시 열림/닫힘
	const toggleAdminMenu = () => {
	  adminMenuOpen.value = !adminMenuOpen.value
	}
	// 라우트가 바뀔 때마다 "기관 관리" 메뉴 닫기
	watch(
	  () => route.name,
	  (newRoute) => {
		// 만약 admin, adminView, organizationMgr 가 아닌 다른 라우트로 이동하면 닫는다
		if (!['admin', 'adminView', 'organizationMgr'].includes(newRoute)) {
		  adminMenuOpen.value = false
		}
	  }
	)
	
	
	const goMenu = (name, force = false) => {
	  // 만약 logo 클릭 시라면 name을 사용자의 권한에 따라 변경
	  if (name === 'logo') {
		if (checkUserId.value.privilege === 'sAdmin') {
		  name = 'organization'
		} else if (checkUserId.value.privilege === 'admin') {
		  name = 'IQCgiasInput'
		} else if (checkUserId.value.privilege === 'user') {
		  name = 'IQAgiasInput'
		}
	  }
	
	  if (!force && route.name === name && name === "giasInput") {
		router.go(0)
	  } else {
		router.push({ name })
	  }
	}
	
	
	const isGiasRoute = computed(() => 
		route.name === 'IQAgiasInput' ||
		route.name === 'IQCgiasInput' ||
		route.name === 'giasStats' ||
		route.name === 'giasEdit' 
	);
	
	const isIQAGiasInputRoute = computed(() => 
			route.name === 'IQAgiasInput'
	);
	
	const isIQCGiasInputRoute = computed(() => 
			route.name === 'IQCgiasInput'
	);
	
	const isGiasStatsRoute = computed(() => 
			route.name === 'giasStats' 
	);
	
	const is2024GiasStatsRoute = computed(() => 
			route.name === 'gias2024Stats' 
	);
	
	const isGiasEditRoute = computed(() => 
			route.name === 'giasEdit' 
	);
	
	const isUserRoute = computed(() => 
			route.name === 'admin' 
	);
	
	const isOrgMgrRoute = computed(() => 
			route.name === 'organizationMgr' 
	);
	
	const isAdminRoute = computed(() => 
			route.name === 'admin' ||
			route.name === 'adminView'||
			route.name === 'organizationMgr'
	);

	// 품질등급 확인서 버튼 노출 여부
	const showcertificateMenu = ref(false)

	const isCertificateRoute = computed(() => 
		route.name === 'certificate'
	);

	const isNoticeRoute = computed(() => 
			route.name === 'noticeList' ||
			route.name === 'register' || 
			route.name === 'noticeView'
			// route.name === 'Home'
	);
	
	const isOrgRoute = computed(() => 
			route.name === 'organization' ||
			route.name === 'organizationView'||
			route.name === 'organizationGiasStats'||
			route.name === 'allOrgStats' ||
			route.name === 'Home'
	);
	
	const isEvalRouter = computed(() => 
		route.name === 'evalList' ||
		route.name === 'createEval'
	);

	const logOut = async () => {
		store.commit('temp/clearUserInfo')
		store.commit('grid/clearSearchParam')
	}
	
	const visitorCounts = ref({
	  dailyCount: 0,
	  weeklyCount: 0,
	  monthlyCount: 0,
	  totalCount: 0,
	});
	
	// onMounted(async () => {
	// 	// try {
	// 	// 	const response = await selectVisitorCount();
	// 	// 	if (response.result === "ok" && response.data) {
	// 	// 	visitorCounts.value = {
	// 	// 		dailyCount: response.data.dailyCount || 0,
	// 	// 		weeklyCount: response.data.weeklyCount || 0,
	// 	// 		monthlyCount: response.data.monthlyCount || 0,
	// 	// 		totalCount: response.data.totalCount || 0,
	// 	// 	};
	// 	// 	} else {
	// 	// 	console.error("방문자 수 조회 실패:", response.resultMsg);
	// 	// 	}
	// 	// } catch (error) {
	// 	// 	console.error("방문자 수 조회 중 오류 발생:", error);
	// 	// }
	// 	console.log("헤더 작동1")
	// });

	onMounted(async () => {
	// 1) 기관 관리자(admin)인지 체크
	if (checkUserId.value?.privilege !== 'admin') {
		showcertificateMenu.value = false
		return
	}

	try {
		const param = {
			organizationCode: checkUserId.value.organizationCode
		}

		// 2) API 호출
		const res = await selectCertStatus(param)

		// API 구조에 맞게 데이터 꺼내기
		const status = res.result 
		// 3) 상태가 ISSUED 또는 DRAFT → 메뉴 보여주기
		if (status == 'ok') {
			showcertificateMenu.value = true
		} else {
			showcertificateMenu.value = false
		}

	} catch (e) {
		console.error("인증서 상태 조회 실패:", e)
		showcertificateMenu.value = false
	}
	})
	</script>
	
	<style scoped>
	/* 로고 스타일 */
	.logo {
	  font-size: 24px; /* 글자 크기 */
	  font-weight: bold;
	  color: white; /* 흰색으로 변경 */
	  padding: 50px 20px; /* 패딩 추가 */
	  border-radius: 5px; /* 모서리 둥글게 */
	  text-align: center;
	  display: inline-block;
	}
	
	/* 기관명 스타일 */
	.login-info {
	  color: white; /* 흰색으로 변경 */
	  font-size: 16px;
	  font-weight: bold;
	  margin-top: 5px;
	  margin-bottom: 10px; /* 아래쪽 여백 추가 */
	}
	
	/* 회원 이름과 환영 메시지 스타일 */
	.login-info__name {
	  font-size: 14px;
	  color: #ddd;
	  margin-top: 10px; /* 위쪽 여백 추가 */
	  display: block; /* 줄 바꿈 */
	}
	
	/* 기관명 안의 유저명 */
	.login-info__name em {
	  font-style: normal;
	  font-weight: bold;
	  color: #ffcc00; /* 강조 색상 (노랑) */
	}
	.visitor-count {
	  background: #122034;
	  padding: 10px;
	  border-radius: 8px;
	  margin: 15px;
	  text-align: left;
	  font-size: 4px !important;
	  font-weight: bold;
	  color: #FFFFFF;
	}
	</style>
	